import React, { Component } from 'react'

import Font from '../../../../../SPRINTA/atoms/Font'
import { Col, Row } from '../../../../../SPRINTA/atoms/Grid'
import Button from '../../../../../SPRINTA/atoms/Button'
import style from './style.css'


class ConfigData extends Component {

  state = {
  }

  render() {

    
    return (
      <Row>
        <Col>
          <Font heading='3' weight="100" style={{marginBottom: '30px'}}>Menu <b>Organizador</b></Font>
        </Col>

        <Col>
          <div className={style.list}>
            <Col size='6 9'>Meus atletas</Col>
            <Col size='6 3'><a href='https://www.sprinta.com.br/dash/reports/athletes/reportAllUsersOrganizer' taget='_blanck'><Button theme='primary'>Exportar</Button></a></Col>
          </div>
        </Col>

      </Row>
    )
  }

}

 export default ConfigData


// WEBPACK FOOTER //
// ./src/App/pages/Profile/Pages/ConfigOrganizer/index.js